import { GetterTree, MutationTree, ActionTree, ActionContext, Module } from 'vuex';
import { RootState } from './RootState';
import { HttpClient } from '@/shared/HttpClient';
import { Message } from '@/shared/models/Message.model';

const traduction = {
    'CORE.DATA.ADDED': 'Les données ont bien été insérées.',
    'CORE.DATA.UPDATED': 'Les données ont bien été mises à jour.',
    'CORE.DATA.DELETED': 'Les données ont bien été supprimées.',
    'CORE.DATA.ENTITY_NOT_FOUND': 'Les données n’ont pas été trouvées.'
};

/**
 * Constantes pour les méthodes du store.
 */
export enum MessageStoreMethods {
    CLEAR_MESSAGES = 'CLEAR_MESSAGES',
    GET_MESSAGES = 'GET_MESSAGES',
    SET_MESSAGES = 'SET_MESSAGES',
    SETUP_AXIOS_INTERCEPTOR = 'SETUP_AXIOS_INTERCEPTOR'
}

/**
 * Classe de gestion des messages d'information et d'erreur provenant du back.
 */
export class MessageState {
    /** Messages retournées du BO */
    public messages: Message[] = [];
}

/**
 * Getters du store.
 */
const getters: GetterTree<MessageState, RootState> = {
    [MessageStoreMethods.GET_MESSAGES]: (state) => state.messages,
};

/**
 * Mutateurs du store.
 */
const mutations: MutationTree<MessageState> = {
    [MessageStoreMethods.CLEAR_MESSAGES]: (state: MessageState) => state.messages = [],
    [MessageStoreMethods.SET_MESSAGES]: (state: MessageState, messages: Message[]) => state.messages = messages
};

/**
 * Actions du store.
 */
const actions: ActionTree<MessageState, RootState> = {
    [MessageStoreMethods.SETUP_AXIOS_INTERCEPTOR]: (store: ActionContext<MessageState, RootState>) => {
        // Interception des réponses pour afficher des messages.
        HttpClient.axios.interceptors.response.use((response: any) => {
            // Si pas de réponse, on déclenche une erreur.
            if (!response || !response.data) {
                return Promise.reject(response);
            }

            // Récupère les messages de la réponse.
            let messages: Message[] = [];
            if (response.data.messages && response.data.messages.length) {
                messages = response.data.messages.map((m) => {
                    m.text = traduction[m.text] || m.text;
                    return m;
                }) || [];
            } else if (Array.isArray(response.data) && response.data.length && response.data[0].text) {
                messages = response.data.map((m) => {
                    m.text = traduction[m.text] || m.text;
                    return m;
                }) || [];
            }

            // Enregistre les nouveaux messages.
            store.commit(MessageStoreMethods.SET_MESSAGES, messages);
            return response;
        });
    }
};

export const MessageStore: Module<MessageState, RootState> = {
    state: new MessageState(),
    getters,
    mutations,
    actions,
    namespaced: false
};
